import Icon from '../components/Icon.vue'

Icon.register({
  'clipboard-check': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M336 64c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48h-288c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h80c0-35.3 28.7-64 64-64s64 28.7 64 64h80zM192 40c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM313.2 271.8c4.7-4.7 4.8-12.2 0.1-17l-28.2-28.4c-4.7-4.7-12.3-4.8-17-0.1l-106 105.2-46-46.4c-4.7-4.7-12.3-4.8-17-0.1l-28.4 28.2c-4.7 4.7-4.8 12.3-0.1 17l82.6 83.3c4.7 4.7 12.3 4.8 17 0.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/clipboard-check.js
// module id = 1199
// module chunks = 0